import { Component, OnInit, ViewChild, ElementRef, AfterViewInit, Renderer2 } from '@angular/core';
import { ApiService } from '../shared/services/api.service';
import { ActivatedRoute, Router } from "@angular/router";
import { ToastrService } from 'ngx-toastr';

@Component({
	selector: 'app-login',
	templateUrl: './login.component.html',
	styleUrl: './login.component.css'
})
export class LoginComponent implements OnInit, AfterViewInit {
	user: any = { email: '', password: '' };
	year: number = new Date().getFullYear();
	ScreenHeight: number = window.innerHeight;
	loadershow: boolean = false;
	loginErrorshow: boolean = false;
	loginFormErr: string = "";
	adminAccess: any;
	data: any = null;
	step: number = 1;
	showQR = false;
	qrToShow: any;
	auth: any = { otp: null };
	qrStep = 1;
	userType: any = localStorage.getItem('userType');

	constructor(private apiService: ApiService, private router: Router, private renderer: Renderer2, private toastr: ToastrService, private route: ActivatedRoute,) { }

	ngAfterViewInit(): void { }

	ngOnInit(): void {
		if (localStorage.getItem('mhs_token') != null && localStorage.getItem('mhs_token') != undefined) {
			this.gotoDashboard();
		}
		if (localStorage.getItem('sessionexpire') == "true") {
			this.loginErrorshow = true;
			this.loginFormErr = "Your session has been expired.";
			setTimeout(() => {
				this.loginErrorshow = false;
				localStorage.removeItem('sessionexpire')
			}, 5000);
		}
	}

	mfasession: any;
	submitForm(user: any) {
		this.loadershow = true;
		this.apiService.loginAPI(user).subscribe({
			next: (data: any) => {
				this.loadershow = false;
				if (data.mfasession) {
					this.mfasession = data.mfasession;
					this.step = 2;
					this.showQR = false;
					this.qrStep = 2;
				} else {
					this.data = data;
					this.proceedLogin();
				}
			}, error: (error: any) => {
				this.loadershow = false;
				this.loginErrorshow = true;
				this.loginFormErr = "Email Or Password is incorrect.";
				setTimeout(() => {
					this.loginErrorshow = false;
				}, 5000);
			}
		});
	}

	next() {
		this.qrStep = 2;
	}

	createImageFromBlob(image: Blob) {
		let reader = new FileReader();
		reader.addEventListener("load", () => {
			this.qrToShow = reader.result;
		}, false);
		if (image) {
			reader.readAsDataURL(image);
		}
	}

	verifyOTP() {
		if (!this.auth.otp) {
			this.toastr.warning("Please enter OTP", 'Error', {
				timeOut: 3000,
				tapToDismiss: true,
				closeButton: true
			});
			return;
		}
		this.loadershow = true;
		let data: any = {
			username: this.user.email,
			session: this.mfasession,
			user_code: this.auth.otp
		};
		this.apiService.loginByMFA(data).subscribe({
			next: (data: any) => {
				this.loadershow = false;
				this.data = data;
				this.proceedLogin();
			}, error: (error: any) => {
				this.loadershow = false;
				this.loginErrorshow = true;
				this.loginFormErr = "Invalid OTP";
				setTimeout(() => {
					this.loginErrorshow = false;
				}, 5000);
			}
		});
	}

	proceedLogin() {
		this.toastr.success("Logged in", 'Success', {
			timeOut: 3000,
			tapToDismiss: true,
			closeButton: true
		});
		this.data["userTypeName"] = this.data["userTypeName"].toLowerCase();
		localStorage.setItem('refreshToken', this.data["refreshtoken"]);
		localStorage.setItem('mhs_token', /* "Bearer " +  */this.data["token"]);
		localStorage.setItem('firstName', this.data["firstName"]);
		localStorage.setItem('lastName', this.data["lastName"]);
		localStorage.setItem('name', this.data["name"]);
		localStorage.setItem('email', this.data["email"]);
		localStorage.setItem('OwnerId', this.data["userId"]);
		localStorage.setItem('userAccess', this.data["userAccess"]);
		localStorage.setItem('userType', this.data["userType"]);
		localStorage.setItem('userTypeId', this.data["userType"]);
		localStorage.setItem('fireString', this.data["fireString"]);
		/* let servicesList: any = this.data["servicesList"];
		for (let i = 0; i < servicesList.length; i++) {
			for (let j = 0; j < this.apiKeys.length; j++) {
				if (servicesList[i].service_name == this.apiKeys[j].service_name) {
					localStorage.setItem(this.apiKeys[j].service_name, servicesList[i].domain_url);
				}
			}
		} */
		this.userType = localStorage.getItem('userType');
		this.gotoDashboard();
	}

	gotoDashboard() {
		let returnUrl = this.route.snapshot.queryParams['returnUrl'] || this.apiService.getHomeURL();
		this.router.navigateByUrl(returnUrl);
	}
}
